<div class="row">
   <div class="col-xs-12">
      <div class="accordion application-form">
         <div class="opener">
            <span class="num last"> 3 <i class="fa fa-check" aria-hidden="true"></i> </span>
            <h1>Identity &amp; Verification - {{ vm.content?.step3ConfirmTitle }}</h1>
         </div>
         <div class="slide">
            <div class="section">
               @if (!timedOut) {
                  <div class="text-center">
                     <app-spinner></app-spinner>
                     <h2>{{ vm.content?.step3ConfirmWaitingTitle }}</h2>
                     <p>{{ vm.content?.step3ConfirmMessage }}</p>
                  </div>
               } @else {
                  <div>
                     <h2>{{ vm.content?.step3ConfirmTimeoutTitle }}</h2>
                     <p>{{ vm.content?.step3ConfirmTimeoutMessage }}</p>
                     <div class="btn-set clearfix">
                        <button type="button" (click)="login()" id="step3ConfirmLoginButton" class="btn btn-primary btn-send">
                           {{ vm.content?.step3ConfirmTimeoutButtonText }}
                        </button>
                     </div>
                  </div>
               }
            </div>
         </div>
      </div>
   </div>
</div>
